"use client";

import { useSiteFlavor } from "@/components/layout/site-flavor-provider";
import { supportMailto } from "@/lib/brand";

interface SupportLink {
  href: string;
  /** Telegram opens in a new tab; a mailto: must not get target/rel. */
  isExternal: boolean;
}

/**
 * Where "contact support" points on the current surface.
 *
 * mint24 routes support through a Telegram bot; getmintai.app must not link to
 * Telegram at all, so it falls back to the Elvo LLC support mailbox. Returns
 * null when a flavor has neither, so callers render nothing rather than a dead
 * link.
 */
export function useSupportLink(): SupportLink | null {
  const { brand } = useSiteFlavor();

  if (brand.supportChatUrl) {
    return { href: brand.supportChatUrl, isExternal: true };
  }

  const mailto = supportMailto(brand);
  return mailto ? { href: mailto, isExternal: false } : null;
}

/** Spread onto an `<a>` so external links get target/rel and mailto: links don't. */
export function externalLinkProps(isExternal: boolean) {
  return isExternal
    ? { target: "_blank" as const, rel: "noopener noreferrer" }
    : {};
}
